import { I_CLASS_MINIMUM } from '../../flows/shared/utils';
import { minimumSummitIClassInvestAmount } from '../../flows/shared/summit.utils';

const filterRDFundsAndGetLinks = (
  allRetirementDateFundsData,
  iClassType = false
) => {
  const prospLinksWithName = allRetirementDateFundsData
    ?.filter(fund => fund.iClass === iClassType)
    ?.map(fund => ({
      linkText: fund.shortName,
      linkURL: `https://prospectus-express.broadridge.com/summary.asp?doctype=pros&clientid=trowepll&fundid=${fund.cusip}`
    }));

  return prospLinksWithName;
};

export const getRDFProspLinks = (
  amount,
  iClassRewards,
  allRetirementDateFundsData
) => {
  let iClassTypeFunds = false;

  if (
    (iClassRewards && Number(amount) >= minimumSummitIClassInvestAmount) ||
    Number(amount) >= I_CLASS_MINIMUM
  ) {
    iClassTypeFunds = true;
  }

  const rdfProspLinks = filterRDFundsAndGetLinks(
    allRetirementDateFundsData,
    iClassTypeFunds
  );
  return rdfProspLinks.sort((a, b) => (a.linkText > b.linkText ? 1 : -1));
};
